import { render, staticRenderFns } from "./masterdata.vue?vue&type=template&id=6c1229ea&scoped=true&lang=pug"
import script from "./masterdata.vue?vue&type=script&lang=ts"
export * from "./masterdata.vue?vue&type=script&lang=ts"
import style0 from "./masterdata.vue?vue&type=style&index=0&id=6c1229ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1229ea",
  null
  
)

export default component.exports